import {  Grid } from '@material-ui/core';

import BoardOverview from './BoardOverview';

export const MyBoards = ({ myBoards }) => {
  return (
    <Grid container spacing={3}>
      {myBoards.map((board) => (
        <Grid item xs={12} sm={6} md={3} key={board.id}>
          <BoardOverview board={board} />
        </Grid>
      ))}
    </Grid>
  );
};
